import { ls } from 'utils/my-localstorage'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { getSelectedCompany, getUserData } from 'store/me'
import {
  ADMIN_PATH,
  ADMINISTRATION_WINE_SITES,
  ADMINISTRATION_RETAIL_PUBLIC_PAGES,
  ADMINISTRATION_MENTIONS,
  ADMINISTRATION_MENTIONS_PRICES,
  ADMINISTRATION_MENTIONS_FACTS,
  BUY_WINE_PATH,
  DATABASE_PATH_PREFIX,
  HOMEPAGE_PATH,
  MY_COMPANY_PATH,
  SELL_WINE_PATH,
  RETAIL,
  CAPTURED_WINES_PATH,
  MY_WINES_E_LABELS,
} from 'utils/consts/path'
import {
  PersonCategories,
  ManagementRoles,
  Roles,
} from 'utils/consts/userRoles'
import {
  Account,
  Administration,
  BuyWine,
  Database,
  Homepage,
  MyCompany,
  MyWines,
  SellWine,
  Retail,
  Elabels,
} from './menu-icons'

export type MenuItem = {
  id: string
  title: string
  icon: FC
  link: string
  forVerifiedOnly?: boolean
  badge?: (state: any) => boolean | number
  items?: Array<{
    id: string
    title: string
    link: string
    forVerifiedOnly?: boolean
    badge?: (state: any) => boolean | number
    isPro?: boolean
  }>
}

export const menuItems = {
  homepage: {
    id: 'homepage',
    icon: Homepage,
    title: 'common.menu.homePage',
    link: HOMEPAGE_PATH,
  },
  capturedWines: {
    id: 'captured-wines',
    icon: MyWines,
    title: 'common.menu.capturedWines',
    link: CAPTURED_WINES_PATH + '/all',
  },

  eLables: {
    id: 'my-wines-e-labels',
    title: 'common.menu.myWinesLabels',
    link: MY_WINES_E_LABELS,
    icon: Elabels,
  },
  sellWine: {
    id: 'sell-wine',
    icon: SellWine,
    title: 'common.menu.sellWine',
    link: SELL_WINE_PATH,
    badge: state =>
      state?.negotiations?.newAnswers?.seller?.buyerConditionsCount > 0 ||
      state?.requests?.notCompletedCount > 0,
    items: [
      {
        id: 'sell-wine-offers',
        title: 'common.menu.sellWineOffers',
        link: SELL_WINE_PATH + '/my-offers',
        badge: state =>
          state?.negotiations?.newAnswers?.seller?.buyerConditionsCount,
      },
      {
        id: 'sell-wine-requests',
        title: 'common.menu.sellWineRequests',
        link: SELL_WINE_PATH + '/requests',
        badge: state => state?.requests?.notCompletedCount,
      },
      {
        id: 'sell-wine-my-warehouses',
        title: 'common.menu.sellWineMyWarehouses',
        link: SELL_WINE_PATH + '/my-warehouses',
      },
    ],
  },
  buyWine: {
    id: 'buy-wine',
    icon: BuyWine,
    title: 'common.menu.buyWine',
    link: BUY_WINE_PATH,
    badge: state =>
      state?.negotiations?.newAnswers?.buyer?.sellerConditionsCount > 0,
    items: [
      {
        id: 'buy-wine-wines',
        title: 'common.menu.buyWineWines',
        link: BUY_WINE_PATH + '/wines',
        forVerifiedOnly: true,
      },
      {
        id: 'buy-wine-offers',
        title: 'common.menu.buyWineOffers',
        link: BUY_WINE_PATH + '/offers',
        badge: state =>
          state?.negotiations?.newAnswers?.buyer?.sellerConditionsCount,
        forVerifiedOnly: true,
      },
      {
        id: 'buy-wine-requests',
        title: 'common.menu.buyWineRequests',
        link: BUY_WINE_PATH + '/my-requests',
      },
      {
        id: 'buy-wine-analysis',
        title: 'common.menu.buyWineAnalysis',
        link: BUY_WINE_PATH + '/analysis',
        forVerifiedOnly: true,
      },
    ],
  },
  retail: {
    id: 'retail',
    icon: Retail,
    title: 'common.menu.retail',
    link: RETAIL,
    items: [
      {
        id: 'retail-e-shops',
        title: 'common.menu.retailEShops',
        link: RETAIL + '/e-shops',
      },
      {
        id: 'retail-geo-indications',
        title: 'common.menu.retailGeoIndications',
        link: RETAIL + '/geo-indications',
        isPro: true,
      },
      {
        id: 'retail-wines',
        title: 'common.menu.retailWines',
        link: RETAIL + '/wines',
        isPro: true,
      },
      {
        id: 'retail-my-range',
        title: 'common.menu.retailMyRange',
        link: RETAIL + '/my-range',
        isPro: true,
      },
      {
        id: 'retail-price-report',
        title: 'common.menu.priceReport',
        link: RETAIL + '/price-report',
        isPro: true,
      },
    ],
  },
  administrationRetail: {
    id: 'retail',
    icon: Retail,
    title: 'common.menu.retail',
    link: RETAIL,
    items: [
      {
        id: 'retail-e-shops',
        title: 'common.menu.retailEShops',
        link: RETAIL + '/e-shops',
      },
      {
        id: 'retail-geo-indications',
        title: 'common.menu.retailGeoIndications',
        link: RETAIL + '/geo-indications',
      },
      {
        id: 'retail-wines',
        title: 'common.menu.retailWines',
        link: RETAIL + '/wines',
      },
      {
        id: 'retail-buyers-wine',
        title: 'common.menu.retailBuyersWine',
        link: RETAIL + '/buyers-wine',
      },
      {
        id: 'retail-price-report',
        title: 'common.menu.priceReport',
        link: RETAIL + '/price-report',
      },
    ],
  },
  myCompany: {
    id: 'my-company',
    icon: MyCompany,
    title: 'common.menu.myCompany',
    link: MY_COMPANY_PATH,
  },

  databasePerson: {
    id: 'database',
    icon: Database,
    title: 'common.menu.database',
    link: DATABASE_PATH_PREFIX,
    items: [
      {
        id: 'database-producers',
        title: 'common.menu.databaseProducers',
        link: DATABASE_PATH_PREFIX + '/producers',
      },
      {
        id: 'database-brands',
        title: 'common.menu.databaseBrands',
        link: DATABASE_PATH_PREFIX + '/brands',
      },
      {
        id: 'wines',
        title: 'common.menu.databaseWines',
        link: DATABASE_PATH_PREFIX + '/wines',
      },
    ],
  },

  databaseManage: {
    id: 'database',
    icon: Database,
    title: 'common.menu.database',
    link: DATABASE_PATH_PREFIX,
    items: [
      {
        id: 'database-producers',
        title: 'common.menu.databaseProducers',
        link: DATABASE_PATH_PREFIX + '/producers',
      },
      {
        id: 'database-brands',
        title: 'common.menu.databaseBrands',
        link: DATABASE_PATH_PREFIX + '/brands',
      },
      {
        id: 'wines',
        title: 'common.menu.databaseWines',
        link: DATABASE_PATH_PREFIX + '/wines',
      },
      {
        id: 'exhibitions',
        title: 'common.menu.databaseExhibitions',
        link: DATABASE_PATH_PREFIX + '/exhibitions',
      },
      {
        id: 'awards',
        title: 'common.menu.databaseAwards',
        link: DATABASE_PATH_PREFIX + '/awards',
      },
      {
        id: 'geo-indication',
        title: 'common.menu.databaseGeoIndication',
        link: DATABASE_PATH_PREFIX + '/geo-indication',
      },
      {
        id: 'kind-of-wine',
        title: 'common.menu.kindOfWine',
        link: DATABASE_PATH_PREFIX + '/kind-of-wine',
      },
      {
        id: 'special-classification-condition',
        title: 'common.menu.specialClassificationCondition',
        link: DATABASE_PATH_PREFIX + '/special-classification-condition',
      },
    ],
  },

  administrationAdmin: {
    id: 'administration',
    icon: Administration,
    title: 'common.menu.administration',
    link: ADMIN_PATH,
    // badge: state => state?.administration?.reviewPendings > 0,
    items: [
      {
        id: 'administration-users',
        title: 'administration.users.title',
        link: ADMIN_PATH + '/users',
      },
    ],
  },
  administrationManager: {
    id: 'administration',
    icon: Administration,
    title: 'common.menu.administration',
    link: ADMIN_PATH,
    items: [
      {
        id: 'administration-companies',
        title: 'administration.companies.title',
        link: ADMIN_PATH + '/companies',
      },
      {
        id: 'administration-reviews',
        title: 'administration.reviews.title',
        link: ADMIN_PATH + '/reviews',
      },
      {
        id: 'administration-offers',
        title: 'administration.offers.title',
        link: ADMIN_PATH + '/offers',
      },
      {
        id: 'administration-requests',
        title: 'administration.requests.title',
        link: ADMIN_PATH + '/requests',
      },
      {
        id: 'administration-images',
        title: 'administration.images.title',
        link: ADMIN_PATH + '/images',
      },
      {
        id: 'administration-e-labels',
        title: 'administration.elabels.title',
        link: ADMIN_PATH + '/e-labels',
      },
      {
        id: 'administration-retail-public-pages',
        title: 'administration.publicUrls.title',
        link: ADMINISTRATION_RETAIL_PUBLIC_PAGES,
      },
      {
        id: 'administration-wine-sites',
        title: 'administration.wineSites.title',
        link: ADMINISTRATION_WINE_SITES,
      },
    ],
  },

  administrationManage: {
    id: 'administration',
    icon: Administration,
    title: 'common.menu.administration',
    link: ADMIN_PATH,
    // badge: state => state?.administration?.reviewPendings > 0,
    items: [
      {
        id: 'administration-users',
        title: 'administration.users.title',
        link: ADMIN_PATH + '/users',
      },
      {
        id: 'administration-companies',
        title: 'administration.companies.title',
        link: ADMIN_PATH + '/companies',
      },
      {
        id: 'administration-reviews',
        title: 'administration.reviews.title',
        link: ADMIN_PATH + '/reviews',
        // badge: state => state?.administration?.reviewPendings,
      },
      {
        id: 'administration-offers',
        title: 'administration.offers.title',
        link: ADMIN_PATH + '/offers',
      },
      {
        id: 'administration-requests',
        title: 'administration.requests.title',
        link: ADMIN_PATH + '/requests',
      },
      {
        id: 'administration-images',
        title: 'administration.images.title',
        link: ADMIN_PATH + '/images',
      },
      {
        id: 'administration-e-labels',
        title: 'administration.elabels.title',
        link: ADMIN_PATH + '/e-labels',
      },
      {
        id: 'administration-retail-public-pages',
        title: 'administration.publicUrls.title',
        link: ADMINISTRATION_RETAIL_PUBLIC_PAGES,
      },
      {
        id: 'administration-price-sources',
        title: 'administration.priceSources.title',
        link: ADMIN_PATH + '/price-sources',
      },
      {
        id: 'administration-wine-sites',
        title: 'administration.wineSites.title',
        link: ADMINISTRATION_WINE_SITES,
      },
      {
        id: 'administration-mentions',
        title: 'administration.mentions.title',
        link: ADMINISTRATION_MENTIONS,
      },
      {
        id: 'administration-clusters',
        title: 'administration.clusters.title',
        link: ADMIN_PATH + '/clusters/potential',
      },
      {
        id: 'administration-verified-relations',
        title: 'administration.verifiedRelations.title',
        link: ADMIN_PATH + '/verified-relations',
      },
      {
        id: 'administration-mentions-prices',
        title: 'administration.mentionsPrices.title',
        link: ADMINISTRATION_MENTIONS_PRICES,
      },
      {
        id: 'administration-mentions-facts',
        title: 'administration.mentionsFacts.title',
        link: ADMINISTRATION_MENTIONS_FACTS,
      },
    ],
  },

  account: {
    id: 'account',
    icon: Account,
    title: 'common.menu.account',
    link: '/acc/user',
    items: [],
  },
} as const

export function useMenuItems(): MenuItem[] {
  const data = useSelector(getUserData)
  const company = useSelector(getSelectedCompany)
  const role = data?.role?.code || ls.getItem('wwl-role_code') || Roles.PERSON

  let items: any[]

  if (role === ManagementRoles.ADMIN) {
    items = [menuItems.administrationAdmin]
  }
  // ?? menuItems.databaseAdmin (producers, brands, wines, exhibitions)
  else if (role === ManagementRoles.SUPERADMIN) {
    items = [
      menuItems.homepage,
      menuItems.administrationManage,
      menuItems.administrationRetail,
      menuItems.databaseManage,
    ]
  } else if (role === ManagementRoles.CONTENT) {
    items = [
      menuItems.administrationManage,
      menuItems.administrationRetail,
      menuItems.databaseManage,
    ]
  } else if (role === ManagementRoles.MANAGER) {
    items = [
      menuItems.administrationManager,
      menuItems.administrationRetail,
      menuItems.databasePerson,
    ]
  } else {
    const category =
      company?.companyCategory?.masterName ||
      ls.getItem('wwl-person_category') ||
      PersonCategories.PERSON

    if (category === PersonCategories.PRODUCER) {
      items = [
        menuItems.capturedWines,
        menuItems.eLables,
        menuItems.sellWine,
        menuItems.retail,
        menuItems.myCompany,
      ]
    } else if (category === PersonCategories.WHOLESALER) {
      items = [
        menuItems.capturedWines,
        menuItems.sellWine,
        menuItems.buyWine,
        menuItems.retail,
        menuItems.myCompany,
      ]
    } else if (category === PersonCategories.RETAILER) {
      items = [
        menuItems.capturedWines,
        menuItems.sellWine,
        menuItems.buyWine,
        menuItems.retail,
        menuItems.myCompany,
      ]
    } else if (category === PersonCategories.RESTAURANT) {
      items = [
        menuItems.capturedWines,
        menuItems.sellWine,
        menuItems.buyWine,
        menuItems.retail,
        menuItems.myCompany,
      ]
    } else {
      items = [menuItems.sellWine, menuItems.myCompany]
    }
  }
  return items
}
